import { useEffect, useRef } from 'react';

/**
 * Variável CSS com a altura (px) do topo fixo da jornada (header escuro + faixa/stepper). É definida no contentor
 * raiz do `StandardJourneyBrandedScreen` e usada por elementos `position: sticky` do conteúdo (ex.: coluna de
 * resumo da cotação) para colarem logo abaixo do topo em vez de ficarem por baixo dele.
 */
export const JOURNEY_STICKY_TOP_VAR = '--journey-sticky-top';

/** Mede o elemento do topo fixo e publica a altura em `JOURNEY_STICKY_TOP_VAR` no elemento raiz. */
export function useJourneyStickyTop<TRoot extends HTMLElement, TTop extends HTMLElement>() {
  const rootRef = useRef<TRoot>(null);
  const topRef = useRef<TTop>(null);

  useEffect(() => {
    const root = rootRef.current;
    const top = topRef.current;
    if (!root || !top) return undefined;

    const publish = () => root.style.setProperty(JOURNEY_STICKY_TOP_VAR, `${Math.round(top.offsetHeight)}px`);
    publish();

    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(publish);
    observer.observe(top);
    return () => observer.disconnect();
  }, []);

  return { rootRef, topRef };
}
